import { useEffect, useRef, useState } from 'react'
import { Keyboard, KeyboardEvent, Platform } from 'react-native'
import { isWeChatBrowser } from '../utils/browser'

const KEYBOARD_THRESHOLD = 100

export const useKeyboard = () => {
  const [keyboardHeight, setKeyboardHeight] = useState(0)
  const [keyboardDisplayed, setKeyboardDisplayed] = useState(false)
  const baselineHeightRef = useRef<number>(0)

  function onKeyboardDidShow(e: KeyboardEvent) {
    setKeyboardHeight(e.endCoordinates.height)
    setKeyboardDisplayed(true)
  }

  function onKeyboardDidHide() {
    setKeyboardHeight(0)
    setKeyboardDisplayed(false)
  }

  useEffect(() => {
    if (Platform.OS === 'web') {
      if (typeof window === 'undefined') return

      baselineHeightRef.current =
        window.visualViewport?.height ?? window.innerHeight

      const detectKeyboard = () => {
        const currentHeight =
          window.visualViewport?.height ?? window.innerHeight
        const diff = baselineHeightRef.current - currentHeight
        const isKeyboardOpen = diff > KEYBOARD_THRESHOLD

        if (!isKeyboardOpen && currentHeight > baselineHeightRef.current) {
          baselineHeightRef.current = currentHeight
        }

        const scrollOffset = window.scrollY || window.pageYOffset || 0
        const adjustedHeight = isKeyboardOpen ? diff - scrollOffset - 15 : 0

        setKeyboardDisplayed(isKeyboardOpen)
        setKeyboardHeight(adjustedHeight)
      }

      const vp = window.visualViewport
      if (vp) {
        vp.addEventListener('resize', detectKeyboard)
        vp.addEventListener('scroll', detectKeyboard)
      }
      window.addEventListener('resize', detectKeyboard)

      return () => {
        if (vp) {
          vp.removeEventListener('resize', detectKeyboard)
          vp.removeEventListener('scroll', detectKeyboard)
        }
        window.removeEventListener('resize', detectKeyboard)
      }
    }

    const showSubscription = Keyboard.addListener(
      'keyboardDidShow',
      onKeyboardDidShow
    )
    const hideSubscription = Keyboard.addListener(
      'keyboardDidHide',
      onKeyboardDidHide
    )
    return () => {
      showSubscription.remove()
      hideSubscription.remove()
    }
  }, [])

  return { keyboardHeight, keyboardDisplayed }
}
